module.exports = __webpack_public_path__ + "img/Calendarleft.fa35dad4.svg";